import React from 'react';
import AddToListButton from '../AddToListButton';

const MediaPoster = ({ 
  imageUrl, 
  alt, 
  itemId, 
  itemType, 
  totalEpisodes,  // Pass total episodes for anime
  totalChapters,  // Pass total chapters for manga
  totalVolumes,   // Pass total volumes for manga
  onStatusChange
}) => {
  return (
    <div className="poster">
      <img src={imageUrl} alt={alt} />
      <AddToListButton
        itemId={itemId}
        itemType={itemType}
        totalEpisodes={totalEpisodes}
        totalChapters={totalChapters}
        totalVolumes={totalVolumes}
        onStatusChange={onStatusChange}
      />
    </div>
  );
};

export default MediaPoster;